import * as React           from "react";

import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {Layout}             from "../layout/layout";
import {OmniSearchLayout}   from "./omni-search-layout/omni-search-layout";
import { PaywallModal } from "@Common/ui-components/paywall-modal/paywall-modal";
import { templateDownloadModal } from "../common/components/template-download-modal/template-download-modal";

export const OmniSearchRoute = ({}) => cs(
    consumeContext("apis"),
    consumeContext("cart"),
    consumeContext("company"),
    consumeContext("routerHistory"),
    consumeContext("session"),
    consumeContext("userLevels"),
    consumeContext("systemConstants"),
    ["paywallModal", ({}, next) => PaywallModal({next})],
    ["templateDownloadModal", ({}, next) => templateDownloadModal({
        allowSocialShare: null,
        templateDownloadUrl: null,
        itemId: "",
        templateId: null,
        templateName: null,
        next
    })],
    ({apis, cart, company, paywallModal, routerHistory, session, systemConstants, templateDownloadModal, userLevels}) => {
        if(session.emulated) {
            session.clearEmulation()
            return null
        }

        return (
            <Layout className="omni-search-route-3ec2" active="omniSearch">
                <OmniSearchLayout {...{
                    apis,
                    cart,
                    company,
                    paywallModal,
                    routerHistory,
                    session,
                    systemConstants,
                    templateDownloadModal,
                    userLevels
                    }}
                />
            </Layout>
        )
    }
)